import { useState } from "react";
import Header from "../../comps/Header";
import Footer from "../../comps/Footer";
import { Link } from "react-router-dom";
import axios from "axios";
import GoogleAuth from "../../comps/GoogleAuth";
import { useNavigate } from 'react-router-dom';
import { user_forgot_password, user_login } from "../../api/Auth"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const Forgot_Password_Email = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ email: "", });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    // Handle input change
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value
        });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData?.password?.length < 8) {
            setError("The password field must be at least 8 characters.")
            setLoading(false)
            return
        }
        setLoading(true);
        setError("");

        const formDataToSend = new FormData();
        formDataToSend.append("email", formData.email);
        try {
            const response = await user_forgot_password(formDataToSend); // Use global function

            if (response?.data?.status == "200") {
                // localStorage.setItem("token", response.token);
                // localStorage.setItem("user", JSON.stringify(response.data));
                // localStorage.setItem("is_user_active", "true");
                toast.success("Password reset email has been sent.!")
                // navigate("/home");
            }
        } catch (error) {
            setError("An unexpected error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    return (
        <div>
            <Header />
            {/* <-------- ToastContainer ------------> */}
            <ToastContainer style={{ marginTop: "120px" }} />
            <section className="relative py-10 md:py-24">
                <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-transparent"></div>
                <div className="mx-auto max-w-7xl px-6 lg:px-8 relative">
                    <div className="flex flex-col items-center justify-center">
                        <div className="w-full bg-white rounded-lg shadow-lg sm:max-w-md">
                            <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                                <p className="font-bold leading-tight tracking-tight text-gray-500">
                                    Lost your password? Please enter your username or email address
                                </p>

                                {error && (
                                    <div className="text-red-500 text-sm font-medium">
                                        {error}
                                    </div>
                                )}

                                <form className="space-y-4" onSubmit={handleSubmit}>
                                    {/* Email Field */}
                                    <div>
                                        <label className="block mb-2 text-sm font-medium text-gray-900">
                                            Your Email ID
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            className="border border-gray-200 text-gray-900 rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full py-2 px-4"
                                            placeholder="name@company.com"
                                            required
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    {/* Submit Button */}
                                    <button type="submit" className="w-full text-white bg-blue-500 hover:bg-blue-600 focus:ring-2 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center" disabled={loading}>
                                        {loading ? "Reseting Password..." : "Reset Password"}
                                    </button>
                                    {/* Signup Link */}
                                    <p className="text-sm text-center text-gray-500">
                                        Already have an account?{" "}
                                        <Link to="/login" className="font-medium text-blue-500 hover:underline">
                                            Sign in
                                        </Link>
                                    </p>
                                    {/* <div className="inline-flex items-center justify-center w-full">
                                        <hr className="w-64 h-1  bg-gray-300 border-0 rounded-sm dark:bg-gray-700" />
                                        <div className="absolute px-4 -translate-x-1/2 text-gray-300 font-semibold left-1/2 bg-white">
                                            or
                                        </div>
                                    </div> */}


                                </form>
                                {/* <GoogleAuth /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Forgot_Password_Email
